import { render, staticRenderFns } from "./TypeAbsences.vue?vue&type=template&id=68fd260e"
import script from "./TypeAbsences.vue?vue&type=script&lang=js"
export * from "./TypeAbsences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports